/**
 * Google Analytics 4 (gtag) helpers.
 * Set REACT_APP_GA_MEASUREMENT_ID (e.g. G-XXXXXXXXXX) to enable.
 * When unset, all calls are no-ops so local/dev builds stay clean.
 */

const MEASUREMENT_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || '').trim();

let initialized = false;

export function isAnalyticsEnabled() {
  return Boolean(MEASUREMENT_ID);
}

export function initAnalytics() {
  if (initialized || !MEASUREMENT_ID || typeof window === 'undefined') {
    return;
  }
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  // SPA navigations send page_view manually via trackPageView.
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  document.head.appendChild(script);
}

export function trackPageView(path, title) {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  const pagePath = path || `${window.location.pathname}${window.location.search}`;
  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(eventName, params = {}) {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  if (!eventName) {
    return;
  }
  window.gtag('event', eventName, params);
}

/** GA4 recommended `share` event for blog share buttons */
export function trackBlogShare(method, post) {
  trackEvent('share', {
    method,
    content_type: 'blog_post',
    item_id: post?.slug || undefined,
    content_id: post?.slug || undefined,
  });
}

/** CTA from blog → Soccer app */
export function trackTeamDividerCta(source = 'blog') {
  trackEvent('select_content', {
    content_type: 'cta',
    item_id: 'soccer_team_divider',
    source,
  });
}

export function trackBlogPostView(slug) {
  if (!slug) return;
  trackEvent('blog_post_view', {
    content_type: 'blog_post',
    item_id: slug,
  });
}
